import { PgtoContratoFinanceiroForm } from "../../../presentation/schemas/ContratoFinanceiro_cadastro/PgtoContratoFinanceiro_form";
import { ICreatePgtoContratoFinanceiroUseCase } from "../../../presentation/useCases/create/create_pgto_contrato_financeiro_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * CreatePgtoContratoFinanceiroUseCase
 */

export class CreatePgtoContratoFinanceiroUseCase implements ICreatePgtoContratoFinanceiroUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async createPgtoContratoFinanceiro(form: PgtoContratoFinanceiroForm): Promise<void> {
    await this.repository.createPgtoContratoFinanceiro(form);

  }
}
